import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';

import CardContent from '@material-ui/core/CardContent';

import { getInputField } from './subscriptor/forms/fields';
import { maintainerForm as styles } from './maintainer/styles';

import { USER_MAX_LENGTH_PASSWORD, USER_MAX_LENGTH_EMAIL } from './../libraries/constants';

import { maximumSubString } from './../libraries/utils';

const LoginForm = props => {
  const { values, classes, handleBlur, errors, touched, setFieldValue } = props;

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue
  };

  return (
    <Card className={classes.loginCard}>
      <CardContent className={classNames(classes.cardContent)}>
        {values ? (
          <React.Fragment>
            {getInputField({
              ...fieldProps,
              name: `username`,
              label: 'Email',
              required: true,
              changeHandler: maximumSubString(USER_MAX_LENGTH_EMAIL),
              formControlClass: classes.fullWidth
            })}

            {getInputField({
              ...fieldProps,
              name: `password`,
              label: 'Contraseña',
              type: 'password',
              placeholder: '',
              required: true,
              changeHandler: maximumSubString(USER_MAX_LENGTH_PASSWORD),
              formControlClass: classes.fullWidth
            })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

LoginForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(LoginForm);
